<template>
  <div class="flex flex-col mx-auto py-10">
    <div>
      <carousel />
    </div>
    <div class="mt-0 lg:mt-2 mx-3 md:mx-0 flex flex-col pb-10">
      <div class="flex flex-row mb-0 md:mb-5 ml-4 md:ml-0 justify-center mt-10">
        <h2 class="font-bold mr-1 uppercase">{{ $t('product.shop-by') }}
          <strong class="font-serif uppercase">{{ $t('product.categories') }}</strong>
        </h2>
      </div>
      <div class="flex flex-wrap lg:flex-nowrap md:mx-40 lg:mx-0 p-6 md:p-0 justify-center items-center">
        <category v-for="category in productCategories" :key="category.id" :category="category"/>
      </div>
      <!-- <brands :productBrands="productBrands" /> -->
  <!--     <router-link
          class="flex justify-center text-b2c-red-300 my-6 text-sm hover:font-bold hover:text-b2c-red-300 cursor-pointer mr-3"
          to="/brands"
          >{{ $t('catalog.view-all') }}→
      </router-link> -->
      <!-- <section class="flex flex-row flex-wrap justify-start w-full pl-2">
        <product-widget v-for="i in 9" :key="i-10" v-show="productCategories.length===0" class="md:w-1/3 w-1/2"/>
      </section>
      <section class="flex flex-col h-auto mt-10" aria-label="Homepage products"
        v-for="category in orderedproductCategories" :key="category.id">
          <product-window :category="category" :isHomepage="true" />
      </section> -->
    </div>
  </div>
</template>

<script>
import Carousel from '@/components/graphics/Carousel.vue';
// import GreySalviLogo from '@/components/graphics/GreySalviLogo.vue';
// import GreyLyonLogo from '@/components/graphics/GreyLyonLogo.vue';
import ProductService from '@/services/ProductService';
/* import ProductWidget from '@/components/ProductWidget.vue';
import ProductWindow from '@/components/graphics/ProductWindow.vue'; */
import { mapGetters } from 'vuex';
// import Brands from '../components/graphics/Brands.vue';
import Category from '../components/graphics/Category.vue';

export default {
  metaInfo() {
    const title = this.$t('titles.default');
    const description = this.$t('metaDescriptions.homepage');
    return {
      title,
      meta: [
        {
          name: 'description',
          content: description,
        },
      ],
    };
  },

  components: {
    Carousel,
    Category,
  },

  data() {
    return {
      productCategories: [],
      productBrands: [],
    };
  },

  created() {
    this.getProductCategories();
    this.getProductBrands();
  },

  computed: {
    ...mapGetters({
      changedLocale: 'auth/changedLocale',
    }),

    orderedProductCategories() {
      const newArray = this.productCategories;
      return newArray.sort((categoryA, categoryB) => categoryB.id < categoryA.id);
    },
  },

  watch: {
    changedLocale() {
      this.getProductCategories();
    },
  },

  methods: {
    getProductCategories() {
      this.productCategories = [];
      ProductService.getProductCategoriesForHomepage().then(({ data }) => {
        this.productCategories = data;
      });
    },

    getProductBrands() {
      this.productBrands = [];
      ProductService.getProductBrandsForHomepage().then((response) => {
        this.productBrands = response.data;
      });
    },
  },
};
</script>
